export enum NewsTypeEnum {
  NEWS = 'NEWS',
  PROMOTION = 'PROMOTION',
}
